export default __webpack_public_path__ + "static/media/featSportDesktop.4efb521d.png";